// only used as a default function for context interface
export function emptyFunction() {
  //console.log('aa');
  //
}
